
<ngx-spinner bdColor="rgba(51,51,51,0.8)"
             size="small"
             color="#fff"
             type="timer"
             fullScreen="false">
  <p style="font-size: 20px; color: white">Please wait...</p>
</ngx-spinner>
